import React from 'react';

const getWindowSize = () => {
  const htmlElement = document?.documentElement;
  if (!htmlElement) {
    /**
     * Initialize state with width/height set to 0 so that the hook works in SSR.
     * Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
     */
    return {
      width: 0,
      height: 0,
    };
  }
  /**
   * Get the current window size and update state
   */
  const {offsetWidth, offsetHeight} = htmlElement;
  const {marginLeft, marginRight, marginTop, marginBottom} =
    window.getComputedStyle(htmlElement);

  const width =
    offsetWidth + parseInt(marginLeft, 10) + parseInt(marginRight, 10);
  const height =
    offsetHeight + parseInt(marginTop, 10) + parseInt(marginBottom, 10);

  return {
    width,
    height,
  };
};

/**
 * Hook that returns the current window size and updates when the window is resized.
 */
export const useWindowSize = () => {
  /**
   * Initialize state with width/height set to 0 so that the hook works in SSR.
   * Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
   */
  const [windowSize, setWindowSize] = React.useState({
    height: 0,
    width: 0,
  });

  React.useEffect(() => {
    /**
     * useEffect only runs on client, so both window & document are safe here.
     */
    function handleResize() {
      setWindowSize(getWindowSize());
    }

    window.addEventListener('resize', handleResize);

    /**
     * Call handler right away so state gets updated with initial window size
     */
    handleResize();

    /**
     * Make sure we clean up after ourselves.
     */
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
};
